import React from 'react';
import { Grid } from "@material-ui/core";
import Button from "@mui/material/Button";
import { dataOnglet } from ".";

const Onglet = (props: any) => {

  //props
  const { active, setActive } = props

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      spacing={2}
      style={{
        background: "aliceblue",
        marginBottom: 10,
        height: "9vh",
        padding: 10,
      }}
    >
      <Grid
        item
        xs={12}
        md={12}
        style={{
          overflowX: "auto", /* Ajouter une barre de défilement horizontale si nécessaire */
          whiteSpace: "nowrap", /* Empêcher les éléments de passer à la ligne */
        }}
      >
        {dataOnglet.map((item: any, index) => (
          <Button
            key={index}
            // startIcon={<AddIcon />}
            variant={active === item.id ? "contained" : "text"}
            onClick={() => setActive(item.id)}
            style={{ marginRight: 5 }}
          >
            {item.libelle}
          </Button>
        ))}
      </Grid>
    </Grid>
  );
};

export default Onglet;
